import React from "react";
import "./quemsomos.css";

import Perfil1 from "./images/lucas.png"; // Substitua pelo caminho correto da imagem
import Perfil2 from "./images/bianca.png"; // Substitua pelo caminho correto da imagem
import InstagramIcon from '../../../../icons/instagramIcon.tsx';

const QuemSomos: React.FC = () => {
    return (
        <section id="quem-somos">
            <div className="container">
                <div className="d-flex justify-content-center pt-4">
                    <div className="quem-somos-text">
                        <h1>Conheça nosso time</h1>
                        <p>
                            Somos um time dedicado a conectar você ao seu público de forma simples e eficaz! 🚀 Desenvolvemos esta plataforma para fortalecer sua presença online, enquanto também atuamos em criação de artes e produção de plaquinhas personalizadas para destacar seu negócio.
                        </p>
                    </div>
                </div>

                <div className="row justify-content-center pb-5">
                    {/* <div className="col-md-5 card-quemsomos">
                        <div className="profile-card">
                            <img src={Perfil1} alt="Lucas Rosa Alves" className="profile-image" />
                            <div className="profile-info">
                                <h4>Lucas Rosa Alves</h4>
                                <p>Desenvolvedor</p>
                                <p className="mb-2">Especialista em tecnologia e criação de plataformas digitais.</p>
                                <a href="https://www.instagram.com/lucasalves.r_/" target="_blank" rel="noopener noreferrer">
                                    <InstagramIcon color="#161B21" height="28" />
                                </a>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-md-5 card-quemsomos">
                        <div className="profile-card">
                            <img src={Perfil2} alt="Bianca da Silva" className="profile-image" />
                            <div className="profile-info">
                                <h4>Bianca da Silva</h4>
                                <p>Captação de Clientes & Designer</p>
                                <p className="mb-2">Especialista em artes, plaquinhas personalizadas e estratégias de engajamento.</p>
                                <a href="https://www.instagram.com/byancasilvaa_/" target="_blank" rel="noopener noreferrer">
                                    <InstagramIcon color="#161B21" height="28" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuemSomos;
